// extracted by mini-css-extract-plugin
module.exports = {"ShortTermsBg":"ShortTerms_ShortTermsBg__xQAFU","HideTitle":"ShortTerms_HideTitle__pOfYX"};